import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Index from "./pages/Index.tsx";

const NotFound = lazy(() => import("./pages/NotFound.tsx"));
const Articles = lazy(() => import("./pages/Articles.tsx"));
const Article = lazy(() => import("./pages/Article.tsx"));
const Unsubscribe = lazy(() => import("./pages/Unsubscribe.tsx"));
const BokforingForening = lazy(() => import("./pages/BokforingForening.tsx"));
const EnStartNonProfit = lazy(() => import("./pages/EnStartNonProfit.tsx"));

const App = () => (
  <BrowserRouter>
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/artiklar" element={<Articles />} />
        <Route path="/artiklar/:slug" element={<Article />} />
        <Route path="/tjanster/bokforing-forening" element={<BokforingForening />} />
        <Route path="/en/start-a-non-profit-association-in-sweden" element={<EnStartNonProfit />} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  </BrowserRouter>
);

export default App;
